import { Box, InputLabel, TextField, Tooltip, Autocomplete } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { useGetContentNavItemsQuery } from "../../../../../shell/services/instance";
import { ContentNavItem, ModelType } from "../../../../../shell/services/types";
type SelectModelParentInputProps = {
  value: string;
  onChange: (value: string) => void;
  modelType: ModelType;
  label?: string;
  tooltip?: string;
};
export const SelectModelParentInput = ({
  value,
  onChange,
  modelType,
  label,
  tooltip = ""
}: SelectModelParentInputProps) => {
  const {
    t
  } = useTranslation();
  const resolvedLabel = label ?? t("schema.modelParent");
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const {
    data: navItems
  } = useGetContentNavItemsQuery();
  const parents = useMemo(() => {
    if (navItems) {
      const _navItems = [...navItems];

      // remove homepage from list of parents only if model type is not dataset
      if (modelType !== "dataset") {
        _navItems?.splice(_navItems?.findIndex(m => m.label === "Homepage"), 1);
      }
      const currentItem = _navItems.find(item => item.contentModelZUID === id);

      // Block doesn't have any nav entry hence we don't need to check it
      if (modelType === "block") {
        return _navItems?.filter(item => item.contentModelZUID !== id)?.sort((a, b) => a.label.localeCompare(b.label));
      } else {
        if (!currentItem) {
          // This would mean that we're creating a NEW model, therefore we would want to show all options
          return _navItems?.sort((a, b) => a.label.localeCompare(b.label));
        } else {
          return _navItems?.filter(item => item.contentModelZUID !== id && currentItem && currentItem.ZUID !== item.parentZUID)?.sort((a, b) => a.label.localeCompare(b.label));
        }
      }
    }
    return [];
  }, [navItems]);
  return <Box data-sentry-element="Box" data-sentry-component="SelectModelParentInput" data-sentry-source-file="SelectModelParentInput.tsx">
      <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="SelectModelParentInput.tsx">
        {resolvedLabel}
        {tooltip && <Tooltip placement="top" title={tooltip}>
            <InfoRoundedIcon sx={{
          ml: 1,
          width: "10px",
          height: "10px"
        }} color="action" />
          </Tooltip>}
      </InputLabel>
      <Autocomplete data-cy="ModelParentSelector" fullWidth renderInput={params => <TextField {...params} placeholder={t("schema.selectPlaceholder")} />} value={navItems?.find(m => m.ZUID === value) || null} options={parents} onChange={(event, value: ContentNavItem) => onChange(value?.ZUID || null)} sx={{
      "& .MuiOutlinedInput-root": {
        padding: "2px"
      }
    }} getOptionKey={option => option.ZUID} data-sentry-element="Autocomplete" data-sentry-source-file="SelectModelParentInput.tsx" />
    </Box>;
};